<div class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/50 backdrop-blur-sm" @backdropAnimation
    (click)="onClose()">

    <!-- Modal Content -->
    <div class="bg-white dark:bg-slate-900 rounded-3xl shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-hidden flex flex-col border border-transparent dark:border-slate-800"
        @modalAnimation (click)="$event.stopPropagation()">

        <!-- Header -->
        <div
            class="flex items-center justify-between px-6 py-4 border-b border-slate-100 dark:border-slate-800 bg-white dark:bg-slate-900 sticky top-0 z-10">
            <div class="flex items-center gap-3">
                <div
                    class="w-10 h-10 rounded-xl bg-amber-50 dark:bg-amber-900/30 text-amber-600 dark:text-amber-400 flex items-center justify-center">
                    <span class="material-icons">receipt_long</span>
                </div>
                <div>
                    <h2 class="text-xl font-bold text-slate-800 dark:text-white tracking-tight">รายละเอียดการจอด</h2>
                    <p class="text-xs text-slate-400 dark:text-slate-500 font-medium">Transaction Detail</p>
                </div>
            </div>
            <div class="flex items-center gap-2">
                <button type="button" (click)="reloadDetail()" [disabled]="isLoading || !parkingTransaction?.id"
                    title="รีโหลดข้อมูล"
                    class="w-8 h-8 flex items-center justify-center rounded-full hover:bg-amber-50 dark:hover:bg-amber-900/30 text-slate-400 dark:text-slate-500 hover:text-amber-600 dark:hover:text-amber-400 transition-colors disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-transparent">
                    <span class="material-icons text-[20px]" [class.animate-spin]="isLoading">refresh</span>
                </button>
                <button type="button" (click)="onClose()"
                    class="w-8 h-8 flex items-center justify-center rounded-full hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 dark:text-slate-500 hover:text-slate-600 dark:hover:text-slate-300 transition-colors">
                    <span class="material-icons">close</span>
                </button>
            </div>
        </div>

        <!-- Content Scroller -->
        <div class="flex-1 overflow-y-auto custom-scrollbar p-6 bg-slate-50/50 dark:bg-slate-900/50">

            <!-- Loading State -->
            <div *ngIf="isLoading"
                class="flex flex-col items-center justify-center py-20 text-slate-400 dark:text-slate-500">
                <span class="material-icons text-4xl mb-2 animate-spin">sync</span>
                <span>กำลังโหลดข้อมูล...</span>
            </div>

            <!-- Error State -->
            <div *ngIf="!isLoading && error" class="flex flex-col items-center justify-center py-20 text-rose-500 dark:text-rose-400">
                <span class="material-icons text-4xl mb-2">error_outline</span>
                <span>{{ error }}</span>
                <button (click)="loadDetail(parkingTransaction!.id)"
                    class="mt-4 px-4 py-2 bg-white dark:bg-slate-800 border border-rose-200 dark:border-rose-900 rounded-lg shadow-sm text-sm font-bold hover:bg-rose-50 dark:hover:bg-rose-900/30 transition-colors text-rose-600 dark:text-rose-400">
                    ลองใหม่อีกครั้ง
                </button>
            </div>

            <!-- Data Content -->
            <div *ngIf="!isLoading && !error && detail" class="flex flex-col gap-6">

                <!-- Vehicle Images Section -->
                <div
                    class="bg-white dark:bg-slate-800 rounded-2xl p-6 shadow-md shadow-slate-200 dark:shadow-slate-900/50 border border-slate-100 dark:border-slate-700 flex flex-col gap-4">
                    <h3 class="text-sm font-bold text-yellow-600 dark:text-white flex items-center gap-2 mb-2 ">
                        <span class="material-icons  dark:text-slate-500 text-sm">image</span> รูปภาพรถ
                    </h3>
                    <div class="">
                        <div class="flex flex-col gap-2 w-full h-70">
                            <span class="text-xs text-slate-400 dark:text-slate-500">รูปภาพเข้า</span>
                            <div class="relative group cursor-pointer overflow-hidden rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-900/50 aspect-video sticky-top-0"
                                (click)="onImageClick(parkingTransaction?.entryPath1 ? 'https://pss-upload.cloud/Parkingcaptures/' + parkingTransaction?.entryPath1 : 'img/notfound.jpg')">
                                <img [src]="parkingTransaction?.entryPath1 ? 'https://pss-upload.cloud/Parkingcaptures/' + parkingTransaction?.entryPath1 : 'img/notfound.jpg'"
                                    class="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105">
                                <div
                                    class="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors flex items-center justify-center">
                                    <span
                                        class="material-icons text-white opacity-0 group-hover:opacity-100 transition-opacity drop-shadow-lg">zoom_in</span>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="flex flex-col gap-2">
                            <span class="text-xs text-slate-400 dark:text-slate-500">รูปภาพออก</span>
                            <div class="relative group cursor-pointer overflow-hidden rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-900/50 aspect-video"
                                (click)="onImageClick(parkingTransaction?.exitPath1 ? 'https://pss-upload.cloud/Parkingcaptures/' + parkingTransaction?.exitPath1 : 'img/notfound.jpg')">
                                <img [src]="parkingTransaction?.exitPath1 ? 'https://pss-upload.cloud/Parkingcaptures/' + parkingTransaction?.exitPath1 : 'img/notfound.jpg'"
                                    class="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105">
                                <div
                                    class="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors flex items-center justify-center">
                                    <span
                                        class="material-icons text-white opacity-0 group-hover:opacity-100 transition-opacity drop-shadow-lg">zoom_in</span>
                                </div>
                            </div>
                        </div> -->
                    </div>
                </div>

                <!-- Top Section: License & Basic Info -->
                <div class="grid grid-cols-1 md:grid-cols-2 gap-6">

                    <!-- Left: Vehicle Info -->
                    <div
                        class="bg-white dark:bg-slate-800 rounded-2xl shadow-md shadow-slate-200 dark:shadow-slate-900/50  border border-slate-100 dark:border-slate-700 ">
                        <div class="flex justify-start items-center px-6 pb-1 pt-5">
                            <h3 class=" text-sm font-bold bg-amber-100 dark:bg-amber-500/20 text-amber-700 dark:text-amber-400 p-2 px-3 shadow shadow-gray-200/50
                            rounded-full dark:text-white flex items-center gap-2 mb-2">
                                <span
                                    class="material-icons text-yellow-600 dark:text-yellow-500 text-sm">directions_car</span>
                                ข้อมูลยานพาหนะ
                            </h3>
                        </div>
                        <div class="px-6 pb-4 flex flex-col gap-4">
                            <div
                                class="flex items-center justify-between py-2 border-b border-slate-50 dark:border-slate-700/50">
                                <span class="text-sm text-slate-500 dark:text-slate-400">ทะเบียนรถ</span>
                                <!-- Since license isn't in detail, we skip or show what's available. Assuming context or future fix. -->
                                <span class="text-md font-bold text-yellow-800 dark:text-white font-display">
                                    <!-- Ideally passed from parent, but for now we rely on existing data -->
                                    {{ detail?.entryLicense }}
                                </span>
                            </div>

                            <div
                                class="flex items-center justify-between py-2 border-b border-slate-50 dark:border-slate-700/50">
                                <span class="text-sm text-slate-500 dark:text-slate-400">ประเภทรถ</span>
                                <span class="text-sm font-bold text-slate-700 dark:text-slate-200">{{
                                    getVehicleTypeName(detail?.vehicleTypeId)
                                    }}</span>
                            </div>

                            <div
                                class="flex items-center justify-between py-2 border-b border-slate-50 dark:border-slate-700/50">
                                <span class="text-sm text-slate-500 dark:text-slate-400">บัตร / สมาชิก</span>
                                <div class="text-right">
                                    <div class="text-sm font-bold flex items-center justify-end gap-1"
                                        [ngClass]="detail?.member ? 'text-yellow-600 dark:text-yellow-500' : 'text-slate-700 dark:text-slate-300'">
                                        <span *ngIf="detail?.member" class="material-icons text-sm">stars</span>
                                        {{ detail?.cardName || '-' }}
                                    </div>
                                    <!-- <div class="text-xs text-slate-400">Type: {{ detail?.cardTypeId || '-' }}</div> -->
                                </div>
                            </div>

                            <div
                                class="flex items-center justify-between py-2 border-b border-slate-50 dark:border-slate-700/50">
                                <span class="text-sm text-slate-500 dark:text-slate-400">ประเภทสมาชิก</span>
                                <span class="px-2 py-0.5 rounded text-xs font-bold"
                                    [ngClass]="detail?.member ? 'bg-emerald-100 text-emerald-600 dark:bg-emerald-900/30 dark:text-emerald-400' : 'bg-slate-100 text-slate-500 dark:bg-slate-700 dark:text-slate-400'">
                                    {{ detail?.member ? 'Member' : 'Visitor' }}
                                </span>
                            </div>
                        </div>

                        <!-- <div class="flex items-center justify-between py-2">
                            <span class="text-sm text-slate-500">CardName</span>
                            <span class="text-sm font-medium text-slate-700">{{ detail?.cardName || '-'
                                }}</span>
                        </div> -->
                    </div>

                    <!-- Right: Time Info -->
                    <div
                        class="bg-white dark:bg-slate-800 rounded-2xl px-6 py-4  shadow-md shadow-slate-200 dark:shadow-slate-900/50  border border-slate-100 dark:border-slate-700 flex flex-col gap-4">
                        <h3
                            class="text-sm font-bold text-green-600 dark:bg-slate-900/50 py-3 border-b border-gray-100 flex items-center gap-2">
                            <span class="material-icons text-green-600 dark:text-green-500 text-sm">schedule</span>
                            เวลาเข้า-ออก
                        </h3>

                        <div class="relative pl-4 space-y-6 border-l-2 border-slate-100 dark:border-slate-700 my-2">
                            <!-- Entry -->
                            <div class="relative">
                                <div
                                    class="absolute -left-[21px] top-1.5 w-3.5 h-3.5 rounded-full bg-green-500 dark:bg-green-400 border-2 border-white dark:border-slate-800 shadow-sm">
                                </div>
                                <div class="flex flex-col">
                                    <span class="text-xs text-slate-400 dark:text-slate-500">เวลาเข้า</span>
                                    <span class="text-sm font-bold text-slate-700 dark:text-slate-200 font-display">
                                        {{ detail?.entryDate ? (detail?.entryDate | date:'dd/MM/yyyy HH:mm') : '-' }}
                                    </span>
                                </div>
                            </div>

                            <!-- Exit -->
                            <div class="relative">
                                <div class="absolute -left-[21px] top-1.5 w-3.5 h-3.5 rounded-full border-2 border-white dark:border-slate-800 shadow-sm"
                                    [ngClass]="detail?.exitDate ? 'bg-rose-500 dark:bg-rose-400' : 'bg-slate-300 dark:bg-slate-600'">
                                </div>
                                <div class="flex flex-col">
                                    <span class="text-xs text-slate-400 dark:text-slate-500">เวลาออก</span>
                                    <span class="text-sm font-bold text-slate-700 dark:text-slate-200 font-display">
                                        {{ detail?.exitDate ? (detail?.exitDate | date:'dd/MM/yyyy HH:mm') : 'ยังไม่ออก'
                                        }}
                                    </span>
                                </div>
                            </div>
                        </div>

                        <!-- Duration (calculated roughly if both exist) -->
                        <!-- <div class="mt-auto pt-4 border-t border-slate-50 flex justify-between items-center" *ngIf="detail?.entryDate && detail?.exitDate">
               <span class="text-sm text-slate-500">ระยะเวลาจอด</span>
               <span class="text-sm font-bold text-slate-800 bg-slate-100 px-2 py-1 rounded-lg">
                 Calculated in Logic
               </span>
            </div> -->
                    </div>


                </div>
                <!-- Bottom Section: Stamps & Finance -->
                <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <!-- Stamps -->
                    <div
                        class="bg-white dark:bg-slate-800 rounded-2xl p-6 shadow-sm border border-slate-100 dark:border-slate-700 flex flex-col h-full overflow-hidden">
                        <h3
                            class="text-sm font-bold text-yellow-600 dark:text-yellow-400 flex items-center gap-2 mb-4 shrink-0">
                            <span class="material-icons text-sm">approval</span>
                            การประทับตรา (Stamps)
                        </h3>
                        <div class="space-y-3 max-h-[380px] overflow-y-auto custom-scrollbar pr-1">
                            <ng-container
                                *ngIf="detail?.parkingStampLists && detail?.parkingStampLists!.length > 0; else noStamps">
                                <div *ngFor="let stamp of detail?.parkingStampLists"
                                    class="flex flex-col bg-yellow-50 dark:bg-yellow-900/50 p-3 rounded-xl border border-yellow-100 dark:border-yellow-700">
                                    <div class="flex justify-between items-start">
                                        <span class="text-sm font-bold text-yellow-700 dark:text-yellow-300">{{
                                            stamp.stampName }}</span>
                                        <span class="text-[10px] text-slate-400 dark:text-slate-500">{{
                                            stamp.stampDate | date:'dd/MM/yy HH:mm' }}</span>
                                    </div>
                                    <div class="text-xs text-slate-500 dark:text-slate-400 mt-1">โดย: {{ stamp.userStamp
                                        }}</div>
                                    <div class="text-xs text-slate-400 dark:text-slate-500 mt-0.5 italic"
                                        *ngIf="stamp.remark">"{{
                                        stamp.remark }}"</div>
                                </div>
                            </ng-container>
                            <ng-template #noStamps>
                                <div class="text-center py-6 text-slate-400 dark:text-slate-500 text-sm italic">
                                    ไม่มีประวัติการประทับตรา
                                </div>
                            </ng-template>
                        </div>
                    </div>

                    <!-- Finance -->
                    <div
                        class="bg-white dark:bg-slate-800 rounded-2xl p-6 shadow-sm border border-slate-100 dark:border-slate-700 flex flex-col h-full overflow-hidden">
                        <h3
                            class="text-sm font-bold text-yellow-600 dark:text-yellow-400 flex items-center gap-2 mb-4 shrink-0">
                            <span class="material-icons text-yellow-600 dark:text-yellow-400 text-sm">payments</span>
                            รายการชำระเงิน (Finance)
                        </h3>
                        <div class="space-y-3 max-h-[380px] overflow-y-auto custom-scrollbar pr-1">
                            <ng-container
                                *ngIf="detail?.parkingFinanceLists && detail?.parkingFinanceLists!.length > 0; else noFinance">
                                <div *ngFor="let fin of detail?.parkingFinanceLists"
                                    class="bg-slate-50 dark:bg-slate-900/50 p-3 rounded-xl border border-slate-100 dark:border-slate-700">
                                    <div class="flex justify-between items-center mb-1">
                                        <span
                                            class="text-xs font-bold text-white bg-blue-500 dark:bg-blue-600 px-2 py-0.5 rounded shadow-sm">{{
                                            fin.receiptNo }}</span>
                                        <span class="text-[10px] text-slate-300 dark:text-slate-500">{{
                                            fin.createDate | date:'dd/MM/yy HH:mm' }}</span>
                                    </div>
                                    <div class="flex justify-between items-center">
                                        <span class="text-sm text-slate-600 dark:text-slate-400">{{ fin.feeName
                                            }}</span>
                                        <span class="text-sm font-bold text-slate-800 dark:text-slate-200">{{ fin.amount
                                            | number:'1.2-2'
                                            }}</span>
                                    </div>
                                    <div class="text-xs text-slate-400 dark:text-slate-500 text-right mt-1">{{
                                        fin.feeTypeName }}</div>
                                </div>
                            </ng-container>
                            <ng-template #noFinance>
                                <div class="text-center py-6 text-slate-400 dark:text-slate-500 text-sm italic">
                                    ไม่มีประวัติการชำระเงิน
                                </div>
                            </ng-template>
                        </div>
                    </div>
                </div>

                <!-- Coupons (city_parking_coupon by transaction_id) -->
                <div
                    class="bg-white dark:bg-slate-800 rounded-2xl p-6 shadow-sm border border-slate-100 dark:border-slate-700 flex flex-col overflow-hidden">
                    <h3
                        class="text-sm font-bold text-violet-600 dark:text-violet-400 flex items-center gap-2 mb-4 shrink-0">
                        <span class="material-icons text-sm">local_offer</span>
                        คูปอง (Coupons)
                        <span *ngIf="detail?.cityParkingCoupons?.length"
                            class="ml-1 text-[10px] font-bold px-2 py-0.5 rounded-full bg-violet-100 text-violet-700 dark:bg-violet-900/40 dark:text-violet-300">
                            {{ detail?.cityParkingCoupons!.length }}
                        </span>
                    </h3>
                    <div class="space-y-3 max-h-[320px] overflow-y-auto custom-scrollbar pr-1">
                        <ng-container
                            *ngIf="detail?.cityParkingCoupons && detail?.cityParkingCoupons!.length > 0; else noCoupons">
                            <div *ngFor="let coupon of detail?.cityParkingCoupons"
                                class="bg-violet-50/80 dark:bg-violet-900/20 p-3 rounded-xl border border-violet-100 dark:border-violet-800/50">
                                <div class="flex justify-between items-start gap-3">
                                    <div class="min-w-0">
                                        <div class="text-sm font-bold text-violet-800 dark:text-violet-200 truncate">
                                            {{ coupon.name || coupon.code || ('#' + coupon.id) }}
                                        </div>
                                        <div class="text-xs text-slate-500 dark:text-slate-400 mt-0.5 font-mono"
                                            *ngIf="coupon.code">
                                            {{ coupon.code }}
                                        </div>
                                    </div>
                                    <span class="shrink-0 px-2 py-0.5 rounded text-[10px] font-bold"
                                        [ngClass]="coupon.enable === false
                                          ? 'bg-slate-200 text-slate-500 dark:bg-slate-700 dark:text-slate-400'
                                          : 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-300'">
                                        {{ coupon.enable === false ? 'ปิดใช้' : 'ใช้งาน' }}
                                    </span>
                                </div>
                                <div class="text-xs text-slate-500 dark:text-slate-400 mt-2 italic"
                                    *ngIf="coupon.details">
                                    {{ coupon.details }}
                                </div>
                                <div class="flex flex-wrap gap-x-4 gap-y-1 mt-2 text-[11px] text-slate-400 dark:text-slate-500">
                                    <span *ngIf="coupon.useDate">
                                        ใช้เมื่อ: {{ coupon.useDate | date:'dd/MM/yyyy HH:mm' }}
                                    </span>
                                    <span *ngIf="coupon.createDate">
                                        สร้าง: {{ coupon.createDate | date:'dd/MM/yyyy HH:mm' }}
                                    </span>
                                </div>
                            </div>
                        </ng-container>
                        <ng-template #noCoupons>
                            <div class="text-center py-6 text-slate-400 dark:text-slate-500 text-sm italic">
                                ไม่มีคูปองที่ผูกกับรายการนี้
                            </div>
                        </ng-template>
                    </div>
                </div>

                <!-- Middle Section: Pricing Breakdown -->
                <div class="bg-white dark:bg-slate-800 rounded-2xl p-6 shadow-md shadow-slate-200 dark:shadow-slate-900/50 border border-slate-200 dark:border-slate-700"
                    *ngIf="detail?.parkingPricing">
                    <h3 class="text-sm font-bold text-yellow-600 dark:text-yellow-400 flex items-center gap-2 mb-4">
                        <span class="material-icons text-sm">calculate</span>
                        สรุปค่าใช้จ่าย
                    </h3>

                    <div class="space-y-3">
                        <div class="flex justify-between text-sm">
                            <span class="text-slate-500 dark:text-slate-400">ค่าจอดรถ (Parking Fee)</span>
                            <span class="font-medium text-slate-700 dark:text-slate-300">{{
                                detail?.parkingPricing!.parkingFee |
                                number:'1.2-2' }}</span>
                        </div>
                        <div class="flex justify-between text-sm" *ngIf="detail?.parkingPricing!.parkingOvernight > 0">
                            <span class="text-slate-500 dark:text-slate-400">ค่าจอดค้างคืน (Overnight)</span>
                            <span class="font-medium text-slate-700 dark:text-slate-300">{{
                                detail?.parkingPricing!.parkingOvernight |
                                number:'1.2-2' }}</span>
                        </div>
                        <div class="flex justify-between text-sm" *ngIf="detail?.parkingPricing!.penaltyFee > 0">
                            <span class="text-slate-500 dark:text-slate-400">ค่าปรับ (Penalty)</span>
                            <span class="font-medium text-rose-500 dark:text-rose-400">{{
                                detail?.parkingPricing!.penaltyFee |
                                number:'1.2-2'
                                }}</span>
                        </div>
                        <div class="flex justify-between text-sm" *ngIf="detail?.parkingPricing!.discount > 0">
                            <span class="text-slate-500 dark:text-slate-400">ส่วนลด (Discount)</span>
                            <span class="font-medium text-emerald-500 dark:text-emerald-400">-{{
                                detail?.parkingPricing!.discount |
                                number:'1.2-2' }}</span>
                        </div>
                        <div class="pl-3 space-y-1.5 border-l-2 border-emerald-200 dark:border-emerald-800"
                            *ngIf="detail?.parkingPricing!.discountDetails?.length">
                            <div *ngFor="let d of detail?.parkingPricing!.discountDetails"
                                class="flex justify-between text-xs text-slate-500 dark:text-slate-400 gap-3">
                                <span class="min-w-0 truncate">
                                    {{ d.ruleName || 'ส่วนลด' }}
                                    <span class="text-slate-400 dark:text-slate-500" *ngIf="d.discountTime > 0">
                                        ({{ d.discountTime }} นาที)</span>
                                </span>
                                <span class="shrink-0 font-medium text-emerald-600 dark:text-emerald-400">-{{
                                    d.discountFee | number:'1.2-2' }}</span>
                            </div>
                        </div>

                        <div class="border-t border-slate-100 dark:border-slate-700/50 my-4 pt-4"></div>

                        <!-- Total Pay Highlight -->
                        <div
                            class="flex justify-between items-center bg-amber-50 dark:bg-amber-900/20 rounded-xl p-4 border border-amber-100 dark:border-amber-900/50">
                            <span class="font-bold text-amber-600 dark:text-amber-500">ยอดรวมทั้งสิ้น</span>
                            <span class="font-extrabold text-amber-600 dark:text-amber-500 text-xl">{{
                                detail?.parkingPricing!.totalPay > 0 ? detail?.parkingPricing!.totalPay : 0 |
                                number:'1.2-2' }}</span>
                        </div>

                        <div class="flex gap-4 mt-2 justify-end text-xs text-slate-400 dark:text-slate-500">
                            <span *ngIf="detail?.parkingPricing!.paidParking > 0">(Paid Parking: {{
                                detail?.parkingPricing!.paidParking | number:'1.2-2' }})</span>
                            <span *ngIf="detail?.parkingPricing!.paidPenalty > 0">(Paid Penalty: {{
                                detail?.parkingPricing!.paidPenalty | number:'1.2-2' }})</span>
                        </div>
                    </div>
                </div>



                <!-- Location Info Section -->
                <div
                    class="bg-white dark:bg-slate-800 rounded-2xl p-6 shadow-xl shadow-slate-200 dark:shadow-slate-900/50 border border-slate-100 dark:border-slate-700 flex flex-col gap-4">
                    <h3 class="text-sm font-bold text-emerald-600 dark:text-emerald-400 flex items-center gap-2 mb-2">
                        <span class="material-icons text-sm">place</span>
                        ข้อมูลสถานที่
                    </h3>
                    <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
                        <!-- Site -->
                        <div class="flex flex-col p-3 rounded-2xl border transition-colors duration-300"
                            [ngClass]="parkingTransaction?.siteName && parkingTransaction?.siteName !== '-' ? 'bg-emerald-50 dark:bg-slate-900/50 border-emerald-200 dark:border-emerald-800/50' : 'bg-red-50 dark:bg-slate-900/50 border-red-200 dark:border-red-800/50'">
                            <span class="text-xs mb-1 font-bold"
                                [ngClass]="parkingTransaction?.siteName && parkingTransaction?.siteName !== '-' ? 'text-emerald-700 dark:text-emerald-400' : 'text-red-600 dark:text-red-400'">Site</span>
                            <div class="flex items-center w-full px-4 py-2 bg-white dark:bg-slate-800 border rounded-full text-sm font-bold transition-colors duration-300 tracking-tight"
                                [ngClass]="parkingTransaction?.siteName && parkingTransaction?.siteName !== '-' ? 'border-emerald-300 dark:border-emerald-600/50 text-emerald-900 dark:text-emerald-300' : 'border-red-300 dark:border-red-600/50 text-red-600 dark:text-red-400'">
                                {{ parkingTransaction?.siteName || '-' }}
                            </div>
                        </div>

                        <!-- Entry Gate (read-only) -->
                        <div class="flex flex-col p-3 rounded-2xl border transition-colors duration-300"
                            [ngClass]="detail?.entryGateId ? 'bg-emerald-50 dark:bg-slate-900/50 border-emerald-200 dark:border-emerald-800/50' : 'bg-red-50 dark:bg-slate-900/50 border-red-200 dark:border-red-800/50'">
                            <span class="text-xs mb-1 font-bold"
                                [ngClass]="detail?.entryGateId ? 'text-emerald-700 dark:text-emerald-400' : 'text-red-600 dark:text-red-400'">Entry
                                Gate</span>
                            <div class="flex items-center w-full px-4 py-2 bg-white dark:bg-slate-800 border rounded-full text-sm font-bold transition-colors duration-300 tracking-tight"
                                [ngClass]="detail?.entryGateId ? 'border-emerald-300 dark:border-emerald-600/50 text-emerald-900 dark:text-emerald-300' : 'border-red-300 dark:border-red-600/50 text-red-600 dark:text-red-400'">
                                {{ getEntryGateName(detail?.entryGateId) }}
                            </div>
                        </div>

                        <!-- Exit Gate (read-only) -->
                        <div class="flex flex-col p-3 rounded-2xl border transition-colors duration-300"
                            [ngClass]="detail?.exitGateId ? 'bg-emerald-50 dark:bg-slate-900/50 border-emerald-200 dark:border-emerald-800/50' : 'bg-red-50 dark:bg-slate-900/50 border-red-200 dark:border-red-800/50'">
                            <span class="text-xs mb-1 font-bold"
                                [ngClass]="detail?.exitGateId ? 'text-emerald-700 dark:text-emerald-400' : 'text-red-600 dark:text-red-400'">Exit
                                Gate</span>
                            <div class="flex items-center w-full px-4 py-2 bg-white dark:bg-slate-800 border rounded-full text-sm font-bold transition-colors duration-300 tracking-tight"
                                [ngClass]="detail?.exitGateId ? 'border-emerald-300 dark:border-emerald-600/50 text-emerald-900 dark:text-emerald-300' : 'border-red-300 dark:border-red-600/50 text-red-600 dark:text-red-400'">
                                {{ getExitGateName(detail?.exitGateId) }}
                            </div>
                        </div>
                    </div>
                </div>







                <!-- Action Buttons Section -->
                <div class="grid grid-cols-2 sm:grid-cols-4 gap-4">
                    <!-- Pay Button -->
                    <button (click)="openPayLink()"
                        class="cursor-pointer flex flex-col items-center justify-center p-4 rounded-2xl bg-gradient-to-br from-blue-500 to-blue-600 dark:from-blue-600 dark:to-blue-700 text-white shadow-lg shadow-blue-200 dark:shadow-blue-900/50 hover:shadow-xl hover:scale-[1.02] transition-all border border-transparent dark:border-blue-500/30">
                        <span class="material-icons text-3xl mb-1">payments</span>
                        <span class="font-bold text-sm">ชำระเงิน</span>
                    </button>

                    <!-- Stamp Button -->
                    <button type="button" (click)="openStampModal()" [disabled]="isLoadingStamps()"
                        class="cursor-pointer flex flex-col items-center justify-center p-4 rounded-2xl bg-gradient-to-br from-emerald-500 to-teal-600 dark:from-emerald-600 dark:to-teal-700 text-white shadow-lg shadow-emerald-200 dark:shadow-emerald-900/50 hover:shadow-xl hover:scale-[1.02] transition-all border border-transparent dark:border-emerald-500/30 disabled:opacity-60 disabled:hover:scale-100">
                        <span class="material-icons text-3xl mb-1">{{ isLoadingStamps() ? 'hourglass_top' : 'approval'
                            }}</span>
                        <span class="font-bold text-sm">{{ isLoadingStamps() ? 'กำลังโหลด...' : 'ประทับตรา' }}</span>
                    </button>

                    <!-- View Member Card Button (Conditional) -->
                    <button *ngIf="detail?.member" (click)="openMemberCardModal()"
                        class="cursor-pointer flex flex-col items-center justify-center p-4 rounded-2xl bg-[#ffe340]/90 dark:bg-yellow-500/20 hover:bg-[#ffe340] dark:hover:bg-yellow-500/30 text-yellow-800 dark:text-yellow-500 shadow-lg shadow-yellow-200/50 dark:shadow-none hover:shadow-xl hover:scale-[1.02] transition-all col-span-2 sm:col-span-1 border border-yellow-300 dark:border-yellow-500/50">
                        <span class="material-icons text-3xl mb-1">badge</span>
                        <span class="font-bold text-sm">บัตรสมาชิก</span>
                    </button>
                </div>




                <!-- Remark Section -->
                <div
                    class="bg-white dark:bg-slate-800 rounded-2xl p-6 shadow-sm border border-slate-100 dark:border-slate-700 flex flex-col gap-4">
                    <h3 class="text-sm font-bold text-slate-800 dark:text-white flex items-center gap-2 mb-2">
                        <span class="material-icons text-slate-400 dark:text-slate-500 text-sm">edit_note</span>
                        หมายเหตุ
                    </h3>
                    <textarea [(ngModel)]="remark" rows="3"
                        class="w-full px-4 py-3 bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-xl text-sm text-slate-700 dark:text-slate-300 placeholder-slate-400 dark:placeholder-slate-500 focus:outline-none focus:border-emerald-500 dark:focus:border-emerald-400 focus:ring-1 focus:ring-emerald-500 dark:focus:ring-emerald-400/50 transition-all resize-none"
                        placeholder="ระบุหมายเหตุ..."></textarea>
                </div>

            </div>

        </div>

        <!-- Footer -->
        <div
            class="px-6 py-4 border-t border-slate-100 dark:border-slate-800 bg-slate-50 dark:bg-slate-900/80 flex justify-between gap-3 z-10 sticky bottom-0">
            <button *ngIf="canShowActivityHistory" type="button" (click)="openActivityHistory()"
                class="px-5 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 font-bold text-slate-600 dark:text-slate-300 hover:border-amber-400 hover:text-amber-600 transition-colors inline-flex items-center gap-2 cursor-pointer">
                <span class="material-icons text-base">history</span>
                ดูประวัติ
            </button>
            <div class="flex justify-end gap-3 ml-auto">
                <button (click)="onClose()"
                    class="px-6 py-2.5 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-300 rounded-xl font-bold shadow-sm hover:bg-slate-50 dark:hover:bg-slate-700 hover:shadow-md transition-all active:scale-95">
                    ยกเลิก
                </button>
            </div>
        </div>

    </div>

    <!-- Member Card Modal (Nested) — ส่ง siteId + cardName จากช่อง บัตร/สมาชิก -->
    <app-modal-transaction-parking-member-card *ngIf="showMemberCardModal"
        [siteId]="detail?.siteId ?? null"
        [cardName]="detail?.cardName || null"
        (close)="closeMemberCardModal()">
    </app-modal-transaction-parking-member-card>

    <!-- Stamp picker modal (same pattern as stamp-apply) -->
    <div *ngIf="showStampModal()"
        class="fixed inset-0 z-[70] flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-md"
        (click)="closeStampModal()">
        <div class="w-full max-w-lg max-h-[85vh] bg-white dark:bg-slate-900 rounded-[2rem] shadow-2xl border border-slate-100 dark:border-slate-800 flex flex-col overflow-hidden"
            (click)="$event.stopPropagation()">
            <div
                class="px-6 py-5 border-b border-slate-100 dark:border-slate-800 bg-amber-50/40 dark:bg-amber-900/10 flex items-start justify-between gap-3">
                <div class="flex items-start gap-3">
                    <div
                        class="w-10 h-10 rounded-xl bg-amber-400 text-slate-900 flex items-center justify-center shrink-0">
                        <span class="material-icons text-[20px]">loyalty</span>
                    </div>
                    <div>
                        <h3 class="text-lg font-black text-slate-900 dark:text-white">ตราประทับ</h3>
                        <p class="text-xs text-slate-400 mt-1">เลือกตราที่ใช้ได้ตามสิทธิ์ของผู้ใช้
                            แล้วใส่หมายเหตุได้ถ้าต้องการ</p>
                    </div>
                </div>
                <button type="button" (click)="closeStampModal()"
                    class="w-9 h-9 rounded-xl text-slate-400 hover:bg-white dark:hover:bg-slate-800 border-none bg-transparent cursor-pointer flex items-center justify-center shrink-0">
                    <span class="material-icons">close</span>
                </button>
            </div>

            <div class="px-4 pt-4 pb-2 border-b border-slate-100 dark:border-slate-800 bg-white dark:bg-slate-900 shrink-0">
              <div class="relative">
                <span class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-[20px]">search</span>
                <input type="text" [ngModel]="stampSearchText()" (ngModelChange)="stampSearchText.set($event)"
                  placeholder="ค้นหาชื่อตรา / กลุ่ม / rate id..."
                  class="w-full h-[42px] pl-10 pr-4 bg-slate-50 dark:bg-slate-800 border border-slate-100 dark:border-slate-700 rounded-xl text-sm font-medium focus:outline-none focus:ring-2 focus:ring-amber-200" />
              </div>
              <p class="text-[11px] text-slate-400 mt-2 font-medium">
                แสดง {{ filteredPickerStamps.length | number }} จาก {{ pickerStamps().length | number }} รายการ
              </p>
            </div>

            <div class="flex-1 overflow-y-auto custom-scrollbar p-4 space-y-2">
                <label *ngFor="let s of filteredPickerStamps"
                    class="flex items-start gap-3 p-3.5 rounded-2xl border cursor-pointer transition-all" [ngClass]="selectedStampId() === s.parkingRateId
              ? 'border-amber-400 bg-amber-50 dark:bg-amber-900/20 shadow-sm shadow-amber-100 dark:shadow-none'
              : 'border-slate-100 dark:border-slate-800 hover:bg-slate-50 dark:hover:bg-slate-800/50'">
                    <input type="radio" name="stampPickDetail" class="mt-1 accent-amber-500"
                        [checked]="selectedStampId() === s.parkingRateId" (change)="selectStamp(s.parkingRateId)" />
                    <div class="min-w-0">
                        <div class="text-[15px] font-black text-slate-900 dark:text-white leading-snug tracking-tight">
                            {{ s.rateName || s.rateId || ('#' + s.parkingRateId) }}
                        </div>
                        <div class="flex flex-wrap items-center gap-2 mt-1.5">
                            <span
                                class="inline-flex items-center px-2 py-0.5 rounded-md text-[11px] font-semibold bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300">
                                {{ s.groupName || 'กลุ่ม' }}
                            </span>
                            <span *ngIf="s.remainingQty != null" class="text-xs text-slate-400 font-medium">
                                เหลือ {{ s.remainingQty }}
                            </span>
                        </div>
                    </div>
                </label>
                <div *ngIf="filteredPickerStamps.length === 0" class="py-10 text-center text-sm text-slate-400">
                  <span class="material-icons text-3xl opacity-40 block mb-2">search_off</span>
                  ไม่พบตราที่ตรงกับคำค้นหา
                </div>
            </div>

            <div
                class="px-5 py-4 border-t border-slate-100 dark:border-slate-800 space-y-3 bg-slate-50/60 dark:bg-slate-900/40">
                <label class="block text-[11px] font-bold text-slate-400 uppercase tracking-wider">หมายเหตุ</label>
                <div
                    class="relative flex items-center bg-white dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 h-[46px]">
                    <span class="absolute left-3 material-icons text-slate-400 text-[18px]">notes</span>
                    <input type="text" [(ngModel)]="stampRemark" placeholder="ถ้ามี (ไม่บังคับ)"
                        class="w-full h-full pl-10 pr-3 bg-transparent border-none text-sm font-medium text-slate-700 dark:text-slate-200 focus:outline-none" />
                </div>
                <div class="flex justify-end gap-2 pt-1">
                    <button type="button" (click)="closeStampModal()"
                        class="px-4 py-2.5 rounded-xl text-sm font-bold bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-300 border-none cursor-pointer">
                        ยกเลิก
                    </button>
                    <button type="button" (click)="confirmApplyStamp()"
                        [disabled]="isApplyingStamp() || !selectedStampId()"
                        class="px-5 py-2.5 rounded-xl text-sm font-black bg-amber-400 hover:bg-amber-500 disabled:opacity-50 text-slate-900 border-none cursor-pointer shadow-md shadow-amber-200/40 dark:shadow-none">
                        {{ isApplyingStamp() ? 'กำลังบันทึก...' : 'ตกลง' }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>

<app-modal-admin-activity-history
  *ngIf="showActivityHistory && parkingTransaction?.id"
  [entityType]="activityEntityTypes.ParkingTransaction"
  [entityId]="parkingTransaction!.id"
  title="ประวัติรายการจอด"
  [subtitle]="'#' + parkingTransaction!.id"
  (close)="closeActivityHistory()">
</app-modal-admin-activity-history>
